"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
class CustomError extends Error {
    constructor(message, key, context, ...params) {
        super(...params);
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            this.stack = new Error(message).stack;
        }
        this.message = message;
        this.key = key || 'UNKNOWN_ERROR';
        this.name = `${this.key}: ${message}`;
        this.data = lodash_1.default.get(context, 'data');
        this.status = lodash_1.default.get(context, 'status');
        this.level = lodash_1.default.get(context, 'level', 'error');
    }
}
exports.default = CustomError;
